import { ASSET_PREFIX } from 'utils/constants';

export type MainPrizeCategoryProps = {
  name: string;
  icon: string;
  selectedIcon: string;
  href: string;
  order: number;
};

export const MAIN_PRIZE_CATEGORIES: Record<string, MainPrizeCategoryProps> = {
  all: {
    name: 'All Prizes',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/all-prizes.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/all-prizes-selected.svg`,
    href: '/prizes',
    order: 0,
  },
  trip: {
    name: 'Trips',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/trips.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/trips-selected.svg`,
    href: '/prizes/trip',
    order: 1,
  },
  experience: {
    name: 'Experiences',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/experience.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/experience-selected.svg`,
    href: '/prizes/experience',
    order: 2,
  },
  lifestyle: {
    name: 'Lifestyle',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/lifestyle.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/lifestyle-selected.svg`,
    href: '/prizes/lifestyle',
    order: 3,
  },
  tech: {
    name: 'Tech',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/tech.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/tech-selected.svg`,
    href: '/prizes/tech',
    order: 4,
  },
  family: {
    name: 'Family',
    icon: `${ASSET_PREFIX}/images/prizes/filter-selector/family.svg`,
    selectedIcon: `${ASSET_PREFIX}/images/prizes/filter-selector/family-selected.svg`,
    href: '/prizes/family',
    order: 5,
  },
};
